export default __webpack_public_path__ + "static/media/zodiac03.a7391a53.png";